

export type PersonType = 'Fyffes Support' | 'You';

export class ChatWithBot {
  person: PersonType;
  response: string;
  fromUser: boolean;
}


export class OpenAiResponse {
	messages: Array<any>;
	threadId: string;
  }

  export class Run {
	id: string;
	status: string;
	thread_id: string;
  }



